import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { SentenceToken } from "../game/types";
import SentenceView from "./SentenceView";

interface Props {
  tokens: SentenceToken[];
}

/**
 * Toggle button that opens the "read as a sentence" popup. Renders nothing
 * when there's no sentence on the table yet. Drop it next to a SentenceTrack.
 */
export default function SentenceViewButton({ tokens }: Props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  if (tokens.length === 0) return null;
  return (
    <>
      <button
        type="button"
        className="btn ghost sentence-view__toggle"
        onClick={() => setOpen(true)}
      >
        ↔ {t("sentenceView.open")}
      </button>
      {open && <SentenceView tokens={tokens} onClose={() => setOpen(false)} />}
    </>
  );
}
